import react from "react";

export const FullAddressWithName = ({
  address,
  includeGst = false,
  includeName = true,
}) => {
  return (
    <p>
      {includeName ? (
        <>
          {address?.user?.full_name}
          <br />
        </>
      ) : (
        <></>
      )}
      {address?.address}, <br />
      {address?.city ? `${address?.city},` : ""}{" "}
      {address?.state ? `${address?.state},` : ""}{" "}
      {address?.city || address?.state ? <br /> : ""}
      {address?.pincode}
      {includeGst && address?.gstin && (
        <>
          <br />
          <br />
          GSTIN: {address.gstin}
        </>
      )}
    </p>
  );
};
